<template>
  <div class='sub-page' style='margin:0 auto;'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='location-main float-left'>
        <dx-data-grid ref='refLocationMainGrid'
          :data-source='locationInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionChanged"
          :auto-navigate-to-focused-row="false"
          key-expr="장소코드"
          :focused-row-key.sync='focusedRowKey'
          @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
          @row-updated='onRowUpdated' @row-updating='onRowUpdating'
          @editor-preparing='onEditorPreparing'
          @init-new-row='onInitNewRow'
          @rowDblClick ='onRowDbClick'
          @toolbar-preparing='onToolbarPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="장소정보"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="(userInfo.permission & crudAllow) > 0"
            :allow-updating="(userInfo.permission & crudAllow) > 0"
            :allow-adding="(userInfo.permission & crudAllow) > 0"
            :use-icons="true"
            mode='row'
          >
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            width="92"
            :buttons="editButtons"
            type="buttons"
          />
          <DxColumn
            :allowEditing='false'
            caption="장소코드"
            data-field="장소코드"
            :visible='false'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="장소명"
            data-field="장소명"
             >
              <dx-required-rule message="장소명을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='isIdEdit'
            caption="장소유형"
            data-field="장소유형코드"
             >
              <DxLookup
                :data-source="locationTypeLookup"
                display-expr="코드명"
                value-expr="코드"
              />
              <dx-required-rule message="장소유형을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="사용유무"
            data-field="사용유무"
            :visible='true'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="삭제유무"
            data-field="삭제유무"
            :visible='true'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="등록일"
            data-field="createtime"
            dataType= 'date'
            format='yyyy-MM-dd'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :visible='true'
            caption="수정일"
            data-field="updatetime"
            dataType= 'date'
            format='yyyy-MM-dd'
             >
          </DxColumn>

          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="장소명"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <!-- *************************************** SUB ***************************-->
      <div class='location-sub float-left'>
        <dx-data-grid ref='refLocationSubGrid'
          :data-source='locationSubInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionSubChanged"
          :auto-navigate-to-focused-row="false"
          key-expr="장소위치코드"
          @row-removed='onRowSubRemoved' @row-inserted='onRowSubInserted' @row-inserting='onRowSubInserting'
          @row-updated='onRowSubUpdated' @row-updating='onRowSubUpdating'
          @editor-preparing='onEditorPreparingSub'
          @init-new-row='onInitNewRowSub'
          @rowDblClick ='onRowSubDbClick'
          @toolbar-preparing='onToolbarPreparingSub'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="장소위치정보"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="(userInfo.permission & crudAllow) > 0"
            :allow-updating="(userInfo.permission & crudAllow) > 0"
            :allow-adding="(userInfo.permission & crudAllow) > 0"
            :use-icons="true"
            mode='row'
          >
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            width="92"
            :buttons="editButtonsSub"
            type="buttons"
          />
          <DxColumn
            :allowEditing='false'
            caption="장소위치코드"
            data-field="장소위치코드"
            :visible='false'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='isIdEdit'
            caption="위치명"
            data-field="위치명"
             >
              <dx-required-rule message="위치명을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="사용유무"
            data-field="사용유무"
            :visible='true'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="삭제유무"
            data-field="삭제유무"
            :visible='true'
            width = '70'>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="등록일"
            data-field="createtime"
            dataType= 'date'
            format='yyyy-MM-dd'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :visible='true'
            caption="수정일"
            data-field="updatetime"
            dataType= 'date'
            format='yyyy-MM-dd'
             >
          </DxColumn>

          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="장소위치코드"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
          <template #location-sub>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
              <b>위치정보({{selectedLocationMain}})</b>
            </div>
          </template>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
    <!-- ********** 위치정보 QRCode ***************** -->
    <DxPopupGen v-if='qrSubOptions !== null'
      :visible.sync="popupSubQrcode"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="450"
      :height="550"
      :title="qrCodePopupSubTitle"
    >
      <QrPrintComponent :qr-options="qrSubOptions"/>
    </DxPopupGen>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel,
  DxLookup } from 'devextreme-vue/data-grid'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import { DxRequiredRule } from 'devextreme-vue/validator'
import QrPrintComponent from '../../share/component/QrPrintComponent'

export default {
  name: 'location',
  data: function () {
    return {
      crudAllow: ConstDef.CRUD_ALLOW_생산_물류,
      isLoading: false,
      selectedIndex: 0,
      tabs: [
        {
          title: '장소관리'
        }
      ],
      editButtons: ['edit', 'delete'],
      locationInfoList: null,
      gridHeight: null,
      userInfo: null,
      isIdEdit: true,
      selectedRow: null,
      locationTypeLookup: null,
      focusedRowKey: null,
      // location sub
      editButtonsSub: ['edit', 'delete', {
        hint: 'QR Code 보기',
        icon: 'print',
        visible: 'true',
        onClick: this.onClickPopupQrCodeSub
      }],
      locationSubInfoList: null,
      isIdEditSub: true,
      selectedRowSub: null,
      // locationSubLookup: null,
      popupSubQrcode: false,
      qrSubOptions: null,
      qrCodePopupSubTitle: null,
      selectedLocationMain: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxTabPanel,
    DxScrolling,
    DxPopupGen,
    DxRequiredRule,
    QrPrintComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.gridHeight = (screen.height - 250) * 0.95
    this.locationTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.장소유형)
    this.refreshLocationMain()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onEditorPreparing (e) {
      if (e.dataField === '장소코드' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (row) {
      console.log(row)
      row.data.사용유무 = true
      row.data.삭제유무 = false
      row.data.장소코드 = 'Z00'
    },
    onRowDbClick (row) {
      // this.$refs.refLocationMainGrid.instance.editRow(row.rowIndex)
    },
    onRowInserted (row) {
      console.log(row)
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userId
      this.$_sp.runInsertAndUpdateIdSqlProc('장소정보', ['장소코드'], ['seqId'], 'seqId', '장소코드', 'Z', AppLib.deleteUnderlineKey(row.data))
        .then((data) => {
          let newData = this.$_sp.MakeModel(data)[0]
          row.data.seqId = newData.seqId
          row.data.장소코드 = newData.장소코드
          this.$refs.refLocationMainGrid.instance.refresh()
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowInserting (row) {
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('장소정보', [{ 장소코드: row.data.장소코드 }])
        .then((data) => {
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error('해당 장소의 위치정보가 등록되어 있습니다. 위치정보부터 삭제 되어야 합니다.')
          } else {
            console.log(error)
          }
          this.refreshLocationMain()
        })
    },
    onRowUpdating (row) {
    },
    onRowUpdated (row) {
      console.log(row)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userId
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('장소정보', ['장소코드'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>장소</b></div>`
          }
        }
      )
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
      this.selectedLocationMain = this.selectedRow.장소명
      this.refreshLocationSub(this.selectedRow.장소코드)
    },
    refreshLocationMain () {
      this.isLoading = true

      this.$_sp.runNoEncodeFindSqlProc('장소정보', null)
        .then((data) => {
          this.locationInfoList = this.$_sp.MakeModel(data)
          this.gridHeight = (screen.height - 250) * 0.95
          this.isLoading = false
          if (this.locationInfoList.length > 0) {
            this.focusedRowKey = this.locationInfoList[0].장소코드
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // ********* Location SUB ******************************************
    onEditorPreparingSub (e) {
      if (e.dataField === '장소위치코드' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEditSub = true
        } else {
          this.isIdEditSub = false
        }
      }
    },
    onInitNewRowSub (row) {
      console.log(row)
      row.data.사용유무 = true
      row.data.삭제유무 = false
      row.data.장소코드 = this.selectedRow.장소코드
      row.data.장소위치코드 = 'Z0000'
    },
    onRowSubDbClick (row) {
      this.$refs.refLocationSubGrid.instance.editRow(row.rowIndex)
    },
    onRowSubInserted (row) {
      console.log(row)
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userId

      // static runInsertAndUpdateIdWithAutoIdSurfixSqlProc (table, pk, exceptKey, autoIdFieldName, updateFieldName, prefix, params) {
      this.$_sp.runInsertAndUpdateIdWithAutoIdSurfixSqlProc('장소위치정보', ['장소위치코드'], ['seqId'], 'seqId', '장소위치코드', `${row.data.장소코드}/`, AppLib.deleteUnderlineKey(row.data))// ('부서정보', array)
        .then((data) => {
          let newData = this.$_sp.MakeModel(data)[0]
          console.log(newData)
          row.data.seqId = newData.seqId
          row.data.장소위치코드 = newData.장소위치코드
          this.$refs.refLocationSubGrid.instance.refresh()
          this.$snotify.info('추가되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowSubInserting (row) {
    },
    onRowSubRemoved (row) {
      this.$_sp.runDeleteSqlProc('장소위치정보', [{ 장소위치코드: row.data.장소위치코드 }])
        .then((data) => {
          this.$snotify.info('삭제되었습니다.')
        })
    },
    onRowSubUpdating (row) {
    },
    onRowSubUpdated (row) {
      console.log(row)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userId
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('장소위치정보', ['장소위치코드'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
    },
    onToolbarPreparingSub (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'location-sub'
        }
      )
    },
    onClickPopupQrCodeSub (e) {
      console.log(e)
      this.qrCodePopupSubTitle = `장소 위치코드(${e.row.data.장소위치코드})`
      this.popupSubQrcode = true
      const base64 = AppLib.getBase64SameLength(`${e.row.data.장소위치코드}`)
      this.qrSubOptions = {
        title: `${this.selectedRow.장소명}:${e.row.data.위치명}`,
        data: base64,
        cellSize: 5,
        text: `${this.selectedRow.장소명}`,
        text2: `${e.row.data.위치명}`,
        name: '창소',
        name2: '위치'
      }
    },
    onSelectionSubChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRowSub = e.row.data
      }
    },
    refreshLocationSub (locationMainCode) {
      this.$_sp.runNoEncodeFindSqlProc('장소위치정보', { '장소코드': locationMainCode })
        .then((data) => {
          this.locationSubInfoList = this.$_sp.MakeModel(data)
          this.gridHeight = (screen.height - 250) * 0.95
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.sub-content{
  .location-main{
    width:49.5%;
    margin-right:1%;
    border:0px solid red;
    min-height: 500px;
  }
  .location-sub{
    width:49.5%;
    border:0px solid red;
    min-height: 500px;
  }
}
</style>
